import DeviceEntry from './DeviceEntry'

export default DeviceEntry
